// Entry point for the build script in your package.json
import '@hotwired/turbo-rails';
import '../javascript/helpers/streamActions';
import moment from "moment";
window.moment = moment;

import * as ActiveStorage from '@rails/activestorage';
ActiveStorage.start();

// This file is responsible for importing all controllers into portal.js to be used
import { Application } from '@hotwired/stimulus';
import { registerControllers } from '@helpers/registerControllers';

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Load all `controller.js` files inside `components/admin/**/controller.js`
const globalControllers = import.meta.glob('../components/global/**/controller.js', { eager: false });
registerControllers(application, globalControllers);

export { application };
